import React from 'react';
import TaskItem from './TaskItem';

const FrontDeskNotificationTask = ({ title, date, description }) => {
  const onSubmit = data => {
    const promise = new Promise(resolve => {
      setTimeout(() => {
        resolve(data);
      }, 2000);
    });

    return promise;
  };

  return (
    <TaskItem
      title={title}
      date={date}
      onSubmit={onSubmit}
      description={description}
      readOnly
      taskItemType="frontDeskNotification"
    />
  );
};

export default React.memo(FrontDeskNotificationTask);
